class Adapter {
  get testContainer() {
    throw new Error('`testContainer` is not implemented for the adapter');
  }

  visit() {
    throw new Error('`visit` is not implemented for the adapter');
  }

  click() {
    throw new Error('`click` is not implemented for the adapter');
  }

  fillIn() {
    throw new Error('`fillIn` is not implemented for the adapter');
  }

  triggerEvent() {
    throw new Error('`triggerEvent` is not implemented for the adapter');
  }

  focus() {
    throw new Error('`focus` is not implemented for the adapter');
  }

  blur() {
    throw new Error('`blur` is not implemented for the adapter');
  }

}

export { Adapter as default };
